import React from 'react'
import {
    Controller,
    useFormState
} from 'react-hook-form'

const CustomTextField = ({ name, label, Component, rules, helperText, type, req, ...restProps }) => {
    const formState = useFormState()

    return (
        <Controller
            name={name}
            sx={{'&-webkit-box-shadow': "#fff" }}
            render={({ field: { onChange, onBlur, value, ref } }) => (
                <Component
                    margin="normal"
                    type={type}
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                    ref={ref}
                    error={Boolean(formState.errors && formState.errors[name])}
                    color="success"
                    helperText={formState.errors[name] ? helperText : null}
                    label={label}
                    // variant="outlined"
                    fullWidth
                    required={req}
                    {...restProps}
                />
            )}
            rules={rules}
        />
    )
}

export default CustomTextField